export default {
      id: "right-arrow-red-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#right-arrow-red-usage",
      toString: function () {
        return this.url;
      }
    }